import { PRODUCT_NAME } from '../brand.js'

/**
 * Session Expired.
 *
 * ┌─ Returns the user to what they were doing ───────────────────────────────┐
 * │ The destination is captured BEFORE redirecting here and restored after   │
 * │ signing in, so someone reading a conversation lands back on that         │
 * │ conversation rather than on a default page. This is frontend only and    │
 * │ needs nothing from the backend.                                          │
 * │                                                                          │
 * │ Worth stating because the lazy implementation — always redirect to the   │
 * │ inbox — is invisible in testing (you were probably on the inbox anyway)  │
 * │ and infuriating in use.                                                  │
 * └──────────────────────────────────────────────────────────────────────────┘
 *
 * With the 10-day sliding window this should be rare: it is reached by being
 * away for ten days, not by working for a while. If users see it often,
 * something is wrong with session extension rather than with this screen.
 */

type Props = {
  /** Where the user was. Shown so the promise to return them is visible. */
  returnTo?: string
  onSignIn: () => void
}

export function SessionExpired({ returnTo, onSignIn }: Props): React.JSX.Element {
  return (
    <div className="auth">
      <div className="auth__card">
        <p className="auth__brand">{PRODUCT_NAME}</p>
        <h1 className="auth__title">Your Session Has Ended</h1>

        <div className="auth__message auth__message--info">
          <p>
            You have been signed out because you were away for a while. Sign in again to
            carry on.
          </p>
          {returnTo !== undefined && returnTo !== '/' && (
            <p>You will be taken back to where you were.</p>
          )}
        </div>

        <button type="button" className="auth__button" onClick={onSignIn} autoFocus>
          Sign In Again
        </button>
      </div>
    </div>
  )
}
